var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C9.8675 6 6.5 9.3675 6.5 13.5C6.5 17.6325 9.8675 21 14 21C18.1325 21 21.5 17.6325 21.5 13.5C21.5 9.3675 18.1325 6 14 6ZM17.585 11.775L13.3325 16.0275C13.2275 16.1325 13.085 16.1925 12.935 16.1925C12.785 16.1925 12.6425 16.1325 12.5375 16.0275L10.415 13.905C10.1975 13.6875 10.1975 13.3275 10.415 13.11C10.6325 12.8925 10.9925 12.8925 11.21 13.11L12.935 14.835L16.79 10.98C17.0075 10.7625 17.3675 10.7625 17.585 10.98C17.8025 11.1975 17.8025 11.55 17.585 11.775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.54ebc3f8c222383aaaf17cdabab718a1.svg";
export { ForwardRef as ReactComponent };